<template>
  <div class="content-modal" v-if="!isSectionDataLoading">
    <div>
      <svg
        class="close-icon"
        @click="$bvModal.hide('UpdateScanCustomFieldsModal')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <div class="header">
      <p>{{ $t('dashboard.grid.editScan')}}</p>
    </div>

    <div class="form-modal-content">
      <div v-if="customSections.length" class="visits-custom-fields vp-mt-32">
        <div
          v-for="(section, index) in customSections"
          :key="index"
          :class="{ 'vp-mb-32': index != customSections.length - 1 }"
        >
          <RenderFieldType
            class="w-100"
            :addSeperator="true"
            :section="section"
            :isEdit="true"
            @updateCustomField="updateCustomField"
            :isDailyLogScanTable="true"
          />
        </div>
      </div>
    </div>

    <div class="footer-btn">
      <button
        @click="onSubmit"
        :disabled="$v.customSections.$invalid || !isFormModified()"
      >
        {{ $t('common.save').toUpperCase()}}
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import RenderFieldType from "@/components/users/section/RenderFieldType";
import { cloneDeep } from "lodash";
import { getCustomFieldsPayload } from "@/utils/mixins/customFieldValueParser";
import sectionService from "@/services/section";
import { requiredIf } from "vuelidate/lib/validators";
export default {
  name: "UpdateScanCustomFieldsModal",
  components: {
    RenderFieldType,
  },
  data() {
    return {
      scanId: null,
      customSections: [],
      isSectionDataLoading: false,
      originalData: [],
    };
  },
  validations: {
    customSections: {
      $each: {
        custom_fields: {
          $each: {
            value: {
              required: requiredIf(function (field) {
                return field.is_mandatory;
              }),
              textMaxLength: function (field, parentField) {
                if (parentField.type != "text") return true;
                if (field?.length > 20) return false;
                return true;
              },
            },
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("authfack", ["currentEntity"]),
  },
  methods: {
    determineDefaultValue(field) {
      let defaultValue = null;

      switch (field.type) {
        case "checkboxes":
          try {
            defaultValue = field.custom_field_value?.value
              ? JSON.parse(field.custom_field_value.value)
              : [];
          } catch (error) {
            console.warn("Failed to parse JSON for checkboxes:", error);
            defaultValue = [];
          }
          break;
        case "toggleButton":
          defaultValue =
            field?.custom_field_value?.value === "1" ||
            field?.custom_field_value?.value === "true" ||
            false;
          break;
        case "number":
        case "longText":
        case "text":
          defaultValue = field?.custom_field_value?.value || "";
          break;
        default:
          defaultValue = field?.custom_field_value?.value || null;
          break;
      }

      return defaultValue;
    },
    async setSections(scanId) {
      // Indicate that loading has started
      this.isSectionDataLoading = true;

      try {
        // Fetch custom sections data
        const response = await sectionService.getSectionDataForDailylog(scanId);
        const customSectionsData = response.data || [];

        // Update the custom sections with modified default values
        this.customSections = customSectionsData.map((section) => ({
          ...section,
          custom_fields: section.custom_fields.map((field) => ({
            ...field,
            value: this.determineDefaultValue(field),
          })),
        }));
        this.originalData = JSON.parse(JSON.stringify(this.customSections));
      } catch (error) {
        console.error("Failed to fetch or process custom sections:", error);
      } finally {
        // Indicate that loading has completed, regardless of success or failure
        this.isSectionDataLoading = false;
      }
    },
    updateCustomField(field) {
      this.$v.customSections.$touch();
      this.customSections?.forEach((section, sectionIndex) => {
        let updatedFieldIndex = section.custom_fields?.findIndex(
          (customField) => customField.id == field.id
        );
        if (updatedFieldIndex >= 0)
          this.customSections[sectionIndex].custom_fields[updatedFieldIndex] =
            field;
      });
      this.customSections = cloneDeep(this.customSections);
    },
    isFormModified() {
      return (
        JSON.stringify(this.customSections) !==
        JSON.stringify(this.originalData)
      );
    },
    async onSubmit() {
      let customFields = getCustomFieldsPayload(this.customSections);
      let formData = new FormData();
      formData.append(
        "custom_fields",
        customFields.length ? JSON.stringify(customFields) : ""
      );
      await sectionService.updateSectionDataForDailylog(this.scanId, formData);
      this.$emit("refreshGrid");
      this.$bvModal.hide("UpdateScanCustomFieldsModal");
    },
  },
  async beforeMount() {
    this.scanId = this.getModalInfo.scanId;
    this.setSections(this.scanId);
  },
};
</script>
<style>
div[id*="UpdateScanCustomFieldsModal___BV_modal_body_"] {
  padding: 40px 42px !important;
}

.content-modal {
  border-radius: 50%;
  h5 {
    margin-bottom: 0;
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    color: #787878;
  }
  .close-icon {
    position: absolute;
    top: 32px;
    inset-inline-end: 32px;
    color: #f46a6a;
    font-size: 1.7rem;
    cursor: pointer;
  }
  .header {
    text-align: center;

    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
    margin: 0 auto 40px;
  }

  .form-modal-content > *:not(:last-child) {
    margin-bottom: 16px;
  }
  .footer-btn {
    margin-top: 40px;
  }
  .footer-btn button:disabled {
    opacity: 1 !important;
    background: #9fb2bf !important;
    cursor: not-allowed;
  }
  .footer-btn button {
    text-align: center;
    letter-spacing: 0.25px;
    width: 416px;
    height: 44px;
    border: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    color: #ffffff;
    border-radius: 22px;
    margin: 0px !important;
    padding: 0px !important;
    background-color: #103f5e;
    text-transform: uppercase;
  }
  .notes {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.25px;
    color: #787878;
    margin: 8px 20px 0;
  }
}
</style>
